import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SuiContainer } from '@splashthat/sui';

import BorderEditor from 'common/components/BorderPicker';
import ColorPickerEditor from 'common/components/ColorPicker';
import Spacer from 'common/components/Spacer';
import { containerPaddingS } from 'common/styles/variables';
import { getColors } from 'common/entities/color/selectors';
import {
    setAllFormSessionTagBorderSizes,
    setFormSessionTagBorderColor,
    setFormSessionTagBorderRadius,
    setFormSessionTagBorderSizeBottom,
    setFormSessionTagBorderSizeLeft,
    setFormSessionTagBorderSizeRight,
    setFormSessionTagBorderSizeTop,
} from 'common/entities/form/styleConfiguration/actions';
import { getTagBorderStyles } from 'common/entities/form/styleConfiguration/selectors';

import { SESSION_DETAILS_QA, TAG_BORDER_QA } from '../../../../utils/qaIdConstants';
import { SESSION_DETAILS_TAG_BORDER_LABEL } from '../../../../constants/formStyleLabels';
import { COLLAPSIBLE_SECTION } from '../../../../constants/reusableClassNames';
import { getFormId } from '../../../../selectors';

const SessionDetailsTagBorderPanel = () => {
    const dispatch = useDispatch();
    const formId = useSelector(getFormId);
    const colorList = useSelector(getColors);
    const { color, radius: borderRadius, ...borderWidths } = useSelector((state) => getTagBorderStyles(state, formId));

    return (
        <SuiContainer className={COLLAPSIBLE_SECTION} data-qa={`${SESSION_DETAILS_QA}--section-${TAG_BORDER_QA}`}>
            <BorderEditor
                borderWidths={borderWidths}
                onBorderWidthsChanged={(widths) => dispatch(setAllFormSessionTagBorderSizes(formId, widths))}
                borderRadius={borderRadius}
                onBorderRadiusChanged={(radius) => dispatch(setFormSessionTagBorderRadius(formId, radius))}
                onChangeTopBorderWidth={(width) => dispatch(setFormSessionTagBorderSizeTop(formId, width))}
                onChangeBottomBorderWidth={(width) => dispatch(setFormSessionTagBorderSizeBottom(formId, width))}
                onChangeRightBorderWidth={(width) => dispatch(setFormSessionTagBorderSizeRight(formId, width))}
                onChangeLeftBorderWidth={(width) => dispatch(setFormSessionTagBorderSizeLeft(formId, width))}
                borderOptionsQa={`${SESSION_DETAILS_QA}--tag-borderOptions`}
                borderDropdownQa={`${SESSION_DETAILS_QA}--tag-borderDropdown`}
                componentLabel={SESSION_DETAILS_TAG_BORDER_LABEL}
            />
            <Spacer $spacing={containerPaddingS} />
            <ColorPickerEditor
                colorList={colorList}
                firstColor={color}
                changeFirstColor={(id) => dispatch(setFormSessionTagBorderColor(formId, id))}
                qaId={SESSION_DETAILS_QA}
            />
        </SuiContainer>
    );
};

export default SessionDetailsTagBorderPanel;
